import { render, staticRenderFns } from "./textCard.vue?vue&type=template&id=15ad091d&scoped=true&"
import script from "./textCard.vue?vue&type=script&lang=js&"
export * from "./textCard.vue?vue&type=script&lang=js&"
import style0 from "./textCard.vue?vue&type=style&index=0&id=15ad091d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad091d",
  null
  
)

export default component.exports